import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import ApiBanner from '@/components/promotion/ApiBanner.vue';
import EnterVoucherText from '@/components/redeem/EnterVoucherText.vue';
import RedeemMaintenance from '@/components/redeem/RedeemMaintenance.vue';
import RedeemTeaser from '@/components/redeem/RedeemTeaser.vue';
import RegionEnterVoucherText from '@/components/redeem/RegionEnterVoucherText.vue';
import ShopWall from '@/components/redeem/shop-wall/ShopWall.vue';
import RegionDiscoverText from '@/components/RegionDiscoverText.vue';
import RegionShopInfoModal from '@/components/RegionShopInfoModal.vue';
// eslint-disable-next-line import/no-cycle
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedeemPage',
  setup(__props) {

const getters = store?.getters;

const maintenance = computed(() => getters.getMaintenanceMode);
const distribution = computed(() => getters.getConfigDistribution);
const voucherCategoryId = computed(() => getters.getVoucherCategoryIdFromConfig);
const configId = computed(() => getters.getConfigId);

onMounted(() => {
  if (
    /^#(search|suche(n|))$/
      .test(window.location?.hash)
  ) {
    const shopWall = document.getElementById('shop-wall');

    setTimeout(() => {
      shopWall
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
    }, 100);
  }
});

return { __sfc: true,getters, maintenance, distribution, voucherCategoryId, configId, ApiBanner, EnterVoucherText, RedeemMaintenance, RedeemTeaser, RegionEnterVoucherText, ShopWall, RegionDiscoverText, RegionShopInfoModal }
}

})